module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"sellingTenders":"Selling Tenders","buyingTenders":"Buying Tenders"},"al":{"sellingTenders":"Shitje Tenderash","buyingTenders":"Blerje Tenderash"}}')
  delete Component.options._Ctor
}
